import React, { useContext } from 'react';
import { BaseContext } from '../contexts/baseContext';

function ResearchContactHeader() {
  const { navigateTo } = useContext(BaseContext);

  return (
    <header className="section-research-contacts-header">
      <div className="research-icon-back">
        <i className="bi bi-arrow-left-short" onClick={() => navigateTo("contacts")} ></i>
      </div>
      <div className="research-input">
        <input type="text" placeholder="enter contact name or number" inputMode="search"/>
      </div>
    </header>
  );
}

export default ResearchContactHeader;
